import { LayoutCanvas } from '../../types/types';
import {
  LAYOUT_DEFAULT_KEY_SIZE_X,
  LAYOUT_DEFAULT_KEY_SIZE_Y,
} from '../../constants';

// Cell (button) size of the fixed grid: gridX × gridY from the canvas, with FE
// fallbacks when the definition doesn't send them.
export const getLayoutFixedCellSize = (
  canvas: LayoutCanvas
): { width: number; height: number } => ({
  width:
    canvas.gridX && canvas.gridX > 0 ? canvas.gridX : LAYOUT_DEFAULT_KEY_SIZE_X,
  height:
    canvas.gridY && canvas.gridY > 0 ? canvas.gridY : LAYOUT_DEFAULT_KEY_SIZE_Y,
});
